import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import Advertisment from '../Advertisment';

export default {
  title: 'Widgets/Anuncios Google'
};

export const BannerWidget = ({ adUnit, keys, sizes, id, lazy }) => {
  const adRefa = useRef();
  return (
    <Advertisment
      adUnit={adUnit}
      sizes={sizes}
      ref={adRefa}
      keys={keys}
      id={id}
      lazy={lazy}
    />
  );
};

BannerWidget.propTypes = {
  adUnit: PropTypes.string.isRequired,
  keys: PropTypes.shape(),
  sizes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  id: PropTypes.string.isRequired,
  lazy: PropTypes.bool
};

BannerWidget.defaultProps = {
  lazy: false,
  keys: {}
};
